import React from 'react';
import ReactDOM from 'react-dom';
import {
  getQuerystring,
  getInfoOfDeviceOS,
  objectToQueryString,
  isApp,
  getClientID,
} from '../../assets/js/common-es6';
import {
  selfcareOriginURL,
  counselingOriginURL,
} from './url';
import Toast from '../layout/toast/toast';
import MiniBanner from '../layout/banner/miniBanner';

const webkitBridgeShowMiniBanner = (data) => {
  const deviceOS = getInfoOfDeviceOS();

  const {
    title,
    description,
    actionData,
    imageURL,
    style,
  } = data;

  const {
    redirectUrl,
    title: redirectTitle,
  } = actionData;

  if (!isApp) {
    const { body } = document;
    const element = document.createElement('div');

    ReactDOM.render(
      <MiniBanner style={style} data={data} />,
      element,
      () => {
        body.style.paddingTop = '38px';
      },
    );

    body.appendChild(element);

    return true;
  }

  const webkitData = JSON.stringify({
    title,
    desc: description,
    link: `hctrost://selfcareWebview?url=${redirectUrl}`,
    image: imageURL,
    backgroundColor: style.backgroundColor,
  });

  try {
    if (deviceOS === 'android') {
      TROST_BRIDGE.showMiniBanner(webkitData);
    }

    if (deviceOS === 'ios') {
      window.webkit.messageHandlers.ShowMiniBanner.postMessage(webkitData);
    }
  } catch (err) {
    console.error(err);
  }

  return true;
};

const webkitBridgeWebviewCustomEvent = (bridgeEventName, callback = false) => {
  const deviceOS = getInfoOfDeviceOS();

  if (!isApp) {
    return false;
  }

  try {
    const data = {
      eventName: bridgeEventName.replace(/ /g, ''),
    };

    const webkitData = JSON.stringify(data);

    if (deviceOS === 'android') {
      TROST_BRIDGE.webViewCustomEvent(webkitData);
    }

    if (deviceOS === 'ios') {
      window.webkit.messageHandlers.WebViewCustomEvent.postMessage(webkitData);
    }
  } catch (err) {
    console.error(err);
  } finally {
    if (callback) {
      callback();
    }
  }

  return true;
};

const webkitBridgeWebviewFirebaseUserProperty = ({
  type = '', userPropertyKey, userPropertyValue, callback = false,
}) => {
  const deviceOS = getInfoOfDeviceOS();

  if (!isApp) {
    return false;
  }

  try {
    const data = {
      key: `${userPropertyKey}`,
      value: `${userPropertyValue}`,
    };

    if (type === 'increment') {
      data.type = 'increment';
      const webkitData = JSON.stringify(data);

      if (deviceOS === 'android') {
        TROST_BRIDGE.mixpanelUserProperty(webkitData);
        TROST_BRIDGE.webViewFirebaseUserProperty(webkitData);
      }

      if (deviceOS === 'ios') {
        window.webkit.messageHandlers.MixpanelUserProperty.postMessage(webkitData);
        window.webkit.messageHandlers.FirebaseUserProperty.postMessage(webkitData);
      }
    } else if (type === 'set') {
      const webkitData = JSON.stringify(data);
      if (deviceOS === 'android') {
        TROST_BRIDGE.mixpanelUserProperty(webkitData);
        // TROST_BRIDGE.webViewFirebaseUserProperty(webkitData);
      }

      if (deviceOS === 'ios') {
        window.webkit.messageHandlers.MixpanelUserProperty.postMessage(webkitData);
        window.webkit.messageHandlers.FirebaseUserProperty.postMessage(webkitData);
      }
    }
  } catch (err) {
    // const properties = {};
    // properties[userPropertyKey] = userPropertyValue;
    //
    // if (type === 'increment') {
    //   mixpanel.people.increment(properties);
    // } else if (type === 'set') {
    //   mixpanel.people.set(properties);
    // }
  } finally {
    if (callback) {
      callback();
    }
  }

  return true;
};

const webkitBridgeWebviewBottomSheet = (bottomSheetURL, bottomSheetTitle, callback = false) => {
  const deviceOS = getInfoOfDeviceOS();

  if (!isApp) {
    return false;
  }

  try {
    const data = {
      url: bottomSheetURL,
      title: bottomSheetTitle,
    };

    const webkitData = JSON.stringify(data);

    if (deviceOS === 'android') {
      TROST_BRIDGE.openBottomSheetWebView(webkitData);
    }

    if (deviceOS === 'ios') {
      window.webkit.messageHandlers.OpenBottomSheetWebView.postMessage(webkitData);
    }
  } catch (err) {
    console.error(err);
  } finally {
    if (callback) {
      callback();
    }
  }

  return true;
};

// forCheck - Adjust, Mixpanel
const forCheck = false;

const webkitBridgeMixpanelScreenView = (bridgeEventName, callback = false) => {
  const deviceOS = getInfoOfDeviceOS();

  // if (!isApp) {
  //   return false;
  // }

  try {
    const data = {
      screenName: bridgeEventName.replace(/ /g, ''),
      url: window.location.href.split('?')[0],
      forCheck,
    };
    const webkitData = JSON.stringify(data);

    if (deviceOS === 'android') {
      TROST_BRIDGE.mixpanelScreenView(data.screenName, data.url, forCheck);
    }

    if (deviceOS === 'ios') {
      window.webkit.messageHandlers.MixpanelScreenView.postMessage(webkitData);
    }
  } catch (err) {
    // mixpanel.track('ScreenView', { 페이지이름: bridgeEventName.replace(/ /g, '') });
  } finally {
    if (callback) {
      callback();
    }
  }

  return true;
};

const webkitBridgeMixpanelCustomEvent = (bridgeEventName, properties, callback = false, checkOnly) => {
  const deviceOS = getInfoOfDeviceOS();

  try {
    const data = {
      eventName: bridgeEventName.replace(/ /g, ''),
      properties,
      forCheck,
    };

    if (checkOnly) {
      data.checkOnly = checkOnly;
    }

    const webkitData = JSON.stringify(data);

    if (deviceOS === 'android') {
      TROST_BRIDGE.mixpanelCustomEvent(webkitData);
    }

    if (deviceOS === 'ios') {
      window.webkit.messageHandlers.MixpanelCustomEvent.postMessage(webkitData);
    }
  } catch (err) {
    // mixpanel.track(bridgeEventTitle, { bridgeEventTitle: bridgeEventName.replace(/ /g, '') });
  } finally {
    if (callback) {
      callback();
    }
  }

  return true;
};

const webkitBridgeMixpanelUserProperty = (userPropertyKey, userPropertyValue, callback = false) => {
  const deviceOS = getInfoOfDeviceOS();

  if (!isApp) {
    return false;
  }

  try {
    const data = {
      key: `${userPropertyKey}`,
      value: `${userPropertyValue}`,
    };
    const webkitData = JSON.stringify(data);

    if (deviceOS === 'android') {
      TROST_BRIDGE.mixpanelUserProperty(webkitData);
    }

    if (deviceOS === 'ios') {
      window.webkit.messageHandlers.MixpanelUserProperty.postMessage(webkitData);
    }
  } catch (err) {
    // mixpanel.track(bridgeEventTitle, { bridgeEventTitle: bridgeEventName.replace(/ /g, '') });
  } finally {
    if (callback) {
      callback();
    }
  }

  return true;
};

const webkitBridgeAdjustEvent = (webkitData, revenue, callback = false) => {
  const deviceOS = getInfoOfDeviceOS();
  const clientID = getClientID();

  let adjustData = {};

  if (typeof webkitData !== 'object') {
    adjustData = {
      code: webkitData,
      revenue: Number(revenue) || 0,
      properties: {
        user_id: clientID,
      },
      forCheck,
    };
  } else {
    adjustData = webkitData;
    adjustData.properties = {
      user_id: clientID,
    };
  }

  try {
    const data = JSON.stringify(adjustData);

    if (deviceOS === 'ios') {
      window.webkit.messageHandlers.AdjustEvent.postMessage(data);
    } else if (deviceOS === 'android') {
      TROST_BRIDGE.adjustEvent(data);
    }
  } catch (e) {
    console.log(e);
  } finally {
    if (callback) {
      callback();
    }
  }
};

const webkitBridgeOpenExternalWeb = (redirectUrl, callback = false) => {
  const deviceOS = getInfoOfDeviceOS();

  if (!isApp) {
    return false;
  }

  try {
    if (deviceOS === 'android') {
      TROST_BRIDGE.openExternalWeb(redirectUrl);
    }

    if (deviceOS === 'ios') {
      window.webkit.messageHandlers.OpenExternalWeb.postMessage(redirectUrl);
    }
  } catch (err) {
    console.error(err);
  } finally {
    if (callback) {
      callback();
    }
  }

  return true;
};

const webkitBridgeShowIndicator = (isShow = false, callback = false) => {
  const deviceOS = getInfoOfDeviceOS();

  if (!isApp) {
    return false;
  }

  try {
    if (deviceOS === 'android') {
      TROST_BRIDGE.showIndicator(isShow);
    }

    if (deviceOS === 'ios') {
      const data = { isShow };
      const webkitData = JSON.stringify(data);
      window.webkit.messageHandlers.ShowIndicator.postMessage(webkitData);
    }
  } catch (err) {
    console.error(err);
  } finally {
    if (callback) {
      callback();
    }
  }

  return true;
};

const webkitBridgeCloseWebview = () => {
  const deviceOS = getInfoOfDeviceOS();

  if (!isApp) {
    return false;
  }

  try {
    if (deviceOS === 'android') {
      TROST_BRIDGE.closeWebView();
    }

    if (deviceOS === 'ios') {
      window.webkit.messageHandlers.CloseWebView.postMessage('');
    }
  } catch (err) {
    console.error(err);
  }

  return true;
};

const webkitBridgeClearCache = (callback = () => {}) => {
  const deviceOS = getInfoOfDeviceOS();

  if (!isApp) {
    return false;
  }

  try {
    if (deviceOS === 'android') {
      TROST_BRIDGE.clearCache();
    }
  } catch (err) {
    console.error(err);
  } finally {
    if (callback) {
      callback();
    }
  }

  return true;
};

const webkitBridgeShowAlert = ({
  title = '',
  message = '',
  alertButton = {},
  callbackType,
}) => {
  const deviceOS = getInfoOfDeviceOS();

  const {
    positiveTitle = '',
    positiveCallback = null,
    negativeTitle = null,
    negativeCallback = null,
  } = alertButton;

  window.locationMovement = locationMovement;

  const callbackTypeString = callbackType ? `window.locationMovement("${callbackType}")` : '';

  try {
    if (deviceOS === 'android') {
      TROST_BRIDGE.showAlert(
        title,
        message,
        positiveTitle,
        callbackTypeString || positiveCallback,
        negativeTitle,
        negativeCallback,
      );
    }

    if (deviceOS === 'ios') {
      const data = {
        title,
        message,
        positiveTitle,
        positiveCallback: callbackTypeString || positiveCallback,
        negativeTitle,
        negativeCallback,
      };

      const webkitData = JSON.stringify(data);

      window.webkit.messageHandlers.ShowAlert.postMessage(webkitData);
    }
  } catch (err) {
    console.log(err);
  }
};

const copyToClipboard = (data) => {
  const clipboard = document.createElement('textarea');
  document.body.appendChild(clipboard);
  clipboard.value = data;
  clipboard.select();
  document.execCommand('copy');
  document.body.removeChild(clipboard);
};

const webkitBridgeWebShare = (url) => {
  if (!url) {
    return false;
  }

  if (getInfoOfDeviceOS() === 'web') {
    copyToClipboard(url);

    alert('링크가 복사되었습니다.');

    return true;
  }

  try {
    const webKitData = {
      title: '',
      text: '',
      url,
    };

    if (isApp && getInfoOfDeviceOS() === 'android') {
      TROST_BRIDGE.webShare(JSON.stringify(webKitData));
    } else {
      window.navigator.share(webKitData);
    }
  } catch {
    copyToClipboard(url);

    alert('링크가 복사되었습니다.');
  }

  return true;
};

function connectToFindPartners(isAppVariable, deviceVariable, partnerId, adjustId) {
  if (isAppVariable) {
    locationMovement('findPartners', { id: partnerId });
  } else if (!isAppVariable && adjustId) {
    window.location.href = 'https://trost.onelink.me/F1Cv/05zw2po0';
  } else if (!isAppVariable && !adjustId && partnerId) {
    if (deviceVariable === 'web') {
      window.location.href = `/service/search/partner/profile/?partnerID=${partnerId}`;
    } else {
      window.location.href = `/mobile/partner/detail/?partnerID=${partnerId}`;
    }
  }
}

function connectToFindPartnersLink(isAppVariable, deviceVariable, partnerId, adjustId) {
  if (isAppVariable) {
    return 'locationMovement';
  } if (!isAppVariable && adjustId) {
    return 'adjust';
  } if (!isAppVariable && !adjustId && partnerId) {
    if (deviceVariable === 'web') {
      return 'pc_web';
    }

    return 'mobile_web';
  }

  return 'pc_web';
}

const locationMovement = (type, data = {}, setState) => {
  const {
    id,
    // groupID,
    title,
    redirectUrl,
    text = '',
    alertButton = {},
    dataTrackingProperties = [{}],
    parameter = {},

    solutionID,
    packageID,
    seasonID,
    paymentIDX,

    callbackType,

    routineGroupID,
    myRoutineGroupID,
  } = data;

  // NOTE:: dataTrackingProperties - 시스템화 되어있지 않은 요소나 locationMovement 를 사용하지 않는 요소는 따로 개별적으로 넣어줘야함.

  if (dataTrackingProperties && Object.keys(dataTrackingProperties).length) {
    dataTrackingProperties.forEach((forEached) => {
      const {
        mixpanelEventName = '',
        mixpanelEventData = {},
        adjustTrackerID = '',
      } = forEached;

      if (mixpanelEventName) webkitBridgeMixpanelCustomEvent(mixpanelEventName, mixpanelEventData);
      if (adjustTrackerID) webkitBridgeAdjustEvent(adjustTrackerID);
    });
  }

  if (type === 'external_web') {
    if (!redirectUrl) {
      return false;
    }

    if (isApp) {
      webkitBridgeOpenExternalWeb(redirectUrl);
    } else {
      window.open(redirectUrl, '_blank');
    }

    return true;
  }

  if (type === 'internal_web') {
    if (!redirectUrl) {
      return false;
    }

    window.location.href = isApp
      ? `hctrost://webview?title=${title}&url=${redirectUrl}`
      : redirectUrl;

    return true;
  }

  if (type === 'modal') {
    if (!redirectUrl) {
      return false;
    }

    window.location.href = isApp
      ? `hctrost://modal?url=${redirectUrl}`
      : redirectUrl;
  }

  if (type === 'selfcare') {
    if (!id && !redirectUrl) {
      if (isApp) {
        window.location.href = 'hctrost://selfcare/';
      } else {
        const redirect = selfcareOriginURL;
        const authUrl = `auth=${encodeURIComponent(window.localStorage.auth) || ''}`;
        const userIDUrl = `userID=${encodeURIComponent(window.localStorage.userID) || ''}`;
        const userNameUrl = `userName=${encodeURIComponent(window.localStorage.userName) || ''}`;

        window.location.href = `${selfcareOriginURL}/interlock/?redirect=${redirect}&${authUrl}&${userIDUrl}&${userNameUrl}`;
      }

      return true;
    }

    // webkitBridgeAdjustEvent('qhljvo');

    let url = '';
    if (redirectUrl) {
      url = redirectUrl;

      if (isApp) {
        window.location.href = `hctrost://selfcareWebview?url=${url}`;
      } else if (url.indexOf('?') !== -1) {
        window.location.href = `${url}&isBack=true`;
      } else {
        window.location.href = `${url}?isBack=true`;
      }
    } else {
      url = `/solutions/${id}`;

      if (isApp) {
        window.location.href = `hctrost://selfcareWebview?url=${url}`;
      } else {
        const redirect = encodeURIComponent(`${selfcareOriginURL}${url}`);
        const authUrl = `auth=${encodeURIComponent(window.localStorage.auth) || ''}`;
        const userIDUrl = `userID=${encodeURIComponent(window.localStorage.userID) || ''}`;
        const userNameUrl = `userName=${encodeURIComponent(window.localStorage.userName) || ''}`;

        window.location.href = `${selfcareOriginURL}/interlock/?redirect=${redirect}&${authUrl}&${userIDUrl}&${userNameUrl}`;
      }
    }

    return true;
  }

  if (type === 'findPartners') {
    if (!id) {
      window.location.href = isApp
        ? 'hctrost://findPartners/'
        : window.location.href = `${counselingOriginURL}/counselor`;
    } else {
      window.location.href = isApp
        ? `hctrost://partnerDetail?counselorId=${id}`
        : `${counselingOriginURL}/mobile/partner/detail/?partnerID=${id}`;
    }

    return true;
  }

  if (type === 'realtimeCounseling') {
    if (isApp) {
      window.location.href = 'hctrost://realtimeCounseling/';
    } else {
      window.location.href = 'https://trost.onelink.me/F1Cv/05zw2po0';
    }

    return true;
  }

  if (type === 'mentalTalk') {
    window.location.href = isApp
      ? 'hctrost://mentalTalk/'
      : `${counselingOriginURL}/service/mentaltalk/poll/search/`;

    return true;
  }

  if (type === 'findHospitals') {
    window.location.href = isApp
      ? 'hctrost://findHospitals/'
      : `${counselingOriginURL}/service/offline/mobile/`;

    return true;
  }

  if (type === 'findMedicines') {
    window.location.href = isApp
      ? 'hctrost://findMedicines/'
      : `${counselingOriginURL}/service/medicine/`;

    return true;
  }

  if (type === 'contentsStory') {
    window.location.href = isApp
      ? 'hctrost://contentsStory/'
      : `${counselingOriginURL}/mobile/contents/story/`;

    return true;
  }

  if (type === 'therapyChatBot') {
    const deviceOS = getInfoOfDeviceOS();

    if (deviceOS === 'android') {
      const count = document.getElementsByClassName('MatchKeywordArea')[0] ? document.getElementsByClassName('MatchKeywordArea')[0].childElementCount : 0;

      window.location.href = isApp
        ? `hctrost://therapyChatBot/?hasKeywords=${Boolean(count)}`
        : 'https://trost.onelink.me/F1Cv/05zw2po0';

      return true;
    }

    window.location.href = isApp
      ? 'hctrost://therapyChatBot/'
      : 'https://trost.onelink.me/F1Cv/05zw2po0';

    // webkitBridgeShowAlert({
    //   title: '지금은 이용이 어려워요.',
    //   message:
    //     '불편을 드려 죄송합니다.\n접근에 문제가 생겨 개발팀이 열심히 고치고 있어요. (뚝딱뚝딱..)\n조금만 기다려 주세요!',
    //   alertButton: {
    //     positiveTitle: '확인',
    //   },
    // });

    return true;
  }

  if (type === 'myCoupon') {
    window.location.href = isApp
      ? 'hctrost://myCoupon/'
      : 'https://trost.onelink.me/F1Cv/05zw2po0';

    return true;
  }

  if (type === 'eventCuration') {
    window.location.href = isApp
      ? 'hctrost://webview?title=이벤트&url=/service/curation/event/'
      : 'https://trost.onelink.me/F1Cv/05zw2po0';

    return true;
  }

  if (type === 'alert') {
    if (isApp) {
      webkitBridgeShowAlert({
        title,
        message: text,
        alertButton,
        callbackType,
      });
    } else {
      alert(text);
    }
  }

  if (type === 'sounds') {
    if (isApp) {
      window.location.href = 'hctrost://sounds/';
    } else {
      alert('모바일 앱에서만 사용할 수 있어요. 트로스트 앱에서 더 다양한 기능을 편하게 이용하세요!');
      window.location.href = 'https://trost.onelink.me/F1Cv/05zw2po0';
    }
  }

  if (type === 'meditationPlayer') {
    if (isApp) {
      window.location.href = `hctrost://meditationPlayer?solutionID=${id}`;
    } else {
      alert('모바일 앱에서만 사용할 수 있어요. 트로스트 앱에서 더 다양한 기능을 편하게 이용하세요!');
      window.location.href = 'https://trost.onelink.me/F1Cv/05zw2po0';
    }
  }

  if (type === 'themePlayer') {
    if (isApp) {
      window.location.href = `hctrost://themePlayer?solutionID=${id}`;
    } else {
      alert('모바일 앱에서만 사용할 수 있어요. 트로스트 앱에서 더 다양한 기능을 편하게 이용하세요!');
      window.location.href = 'https://trost.onelink.me/F1Cv/05zw2po0';
    }
  }

  if (type === 'meditation') {
    if (isApp) {
      window.location.href = `hctrost://selfcareWebview?url=/sounds/meditation/${id}`;
    } else {
      const redirect = encodeURIComponent(`${selfcareOriginURL}/sounds/meditation/${id}`);
      const authUrl = `auth=${encodeURIComponent(window.localStorage.auth) || ''}`;
      const userIDUrl = `userID=${encodeURIComponent(window.localStorage.userID) || ''}`;
      const userNameUrl = `userName=${encodeURIComponent(window.localStorage.userName) || ''}`;

      window.location.href = `${selfcareOriginURL}/interlock/?redirect=${redirect}&${authUrl}&${userIDUrl}&${userNameUrl}`;
    }
  }

  if (type === 'soundsCatalogue') {
    if (isApp) {
      window.location.href = `hctrost://selfcareWebview?url=/sounds/catalogue/${id}`;
    } else {
      const redirect = encodeURIComponent(`${selfcareOriginURL}/sounds/catalogue/${id}`);
      const authUrl = `auth=${encodeURIComponent(window.localStorage.auth) || ''}`;
      const userIDUrl = `userID=${encodeURIComponent(window.localStorage.userID) || ''}`;
      const userNameUrl = `userName=${encodeURIComponent(window.localStorage.userName) || ''}`;

      window.location.href = `${selfcareOriginURL}/interlock/?redirect=${redirect}&${authUrl}&${userIDUrl}&${userNameUrl}`;
    }
  }

  if (type === 'findPartners-filter') {
    // toClick = <span>맞춤상담사추천</span>
    // const toClick = document.getElementsByClassName('clickableKeyword')[0].children[0].children[0].children[0].children[0].children[0];
    // toClick.click();
  }

  if (type === 'partnerFilter') {
    const parameters = window.filter ? objectToQueryString(window.filter) : '';

    if (isApp) {
      webkitBridgeWebviewBottomSheet(`/mobile/partner/search/filter/${parameters}`, '상담사 정렬·필터');
    } else {
      window.location.href = `/mobile/partner/search/filter/${parameters}`;
    }
  }

  if (type === 'selectKeyword') {
    if (isApp) {
      window.location.href = `hctrost://selfcareWebview?url=${counselingOriginURL}/mobile/select/keyword/`;
    } else {
      window.location.href = `${counselingOriginURL}/mobile/select/keyword/?redirectUrl=${window.location.href}`;
    }
  }

  // for jessi
  if (type === 'goToMyPackage') {
    if (isApp || localStorage.isApp) {
      let params = '';

      if (parameter && Object.keys(parameter).length) {
        params = objectToQueryString(parameter);
      }

      window.location.href = `hctrost://selfcareWebview?url=${counselingOriginURL}/promotion/guide/${id}/${params || ''}`;
    }
  }

  if (type === 'workshopReview') {
    if (isApp) {
      window.location.href = `hctrost://workshopReview?solutionID=${solutionID}&packageID=${packageID}&seasonID=${seasonID}&paymentIDX=${paymentIDX}`;
    } else {
      alert('모바일 앱에서만 사용할 수 있어요. 트로스트 앱에서 더 다양한 기능을 편하게 이용하세요!');
      window.location.href = 'https://trost.onelink.me/F1Cv/05zw2po0';
    }
  }

  if (type === 'showToast') {
    setState(<Toast message={title} snackBarOnClickText={text} snackBarOnClickFunction={() => { locationMovement(callbackType); }} />);
    window.setTimeout(() => { setState(''); }, 2000);
  }

  if (type === 'updatePhoneNumber') {
    window.location.href = `${selfcareOriginURL}/sign/update?action=back`;
  }

  if (type === 'emotionDiary') {
    if (isApp) {
      window.location.href = 'hctrost://emotionDiary/';
    } else {
      alert('모바일 앱에서만 사용할 수 있어요. 트로스트 앱에서 더 다양한 기능을 편하게 이용하세요!');
      window.location.href = 'https://trost.onelink.me/F1Cv/05zw2po0';
    }
  }

  if (type === 'routine') {
    if (isApp) {
      window.location.href = 'hctrost://routine/';
    } else {
      // alert(
      //   '모바일 앱에서만 사용할 수 있어요. 트로스트 앱에서 더 다양한 기능을 편하게 이용하세요!',
      // );
      window.location.href = 'https://trost.onelink.me/F1Cv/05zw2po0';
    }
  }

  if (type === 'routinePlayer') {
    if (isApp) {
      if (routineGroupID) {
        window.location.href = `hctrost://routinePlayer?routineGroupID=${routineGroupID}`;
      }
    } else {
      // alert(
      //   '모바일 앱에서만 사용할 수 있어요. 트로스트 앱에서 더 다양한 기능을 편하게 이용하세요!',
      // );
      window.location.href = 'https://trost.onelink.me/F1Cv/05zw2po0';
    }
  }

  if (type === 'addRoutine') {
    if (isApp) {
      if (routineGroupID) {
        window.location.href = `hctrost://addRoutine?routineGroupID=${routineGroupID}`;
      }
    } else {
      // alert(
      //   '모바일 앱에서만 사용할 수 있어요. 트로스트 앱에서 더 다양한 기능을 편하게 이용하세요!',
      // );
      window.location.href = 'https://trost.onelink.me/F1Cv/05zw2po0';
    }
  }

  if (type === 'editRoutine') {
    if (isApp) {
      if (routineGroupID) {
        window.location.href = `hctrost://editRoutine?routineGroupID=${routineGroupID}&myRoutineGroupIdx=${myRoutineGroupID}`;
      }
    } else {
      // alert(
      //   '모바일 앱에서만 사용할 수 있어요. 트로스트 앱에서 더 다양한 기능을 편하게 이용하세요!',
      // );
      window.location.href = 'https://trost.onelink.me/F1Cv/05zw2po0';
    }
  }

  if (type === 'today') {
    window.location.href = 'hctrost://today';
  }

  if (type === 'myEnergy') {
    if (isApp) {
      window.location.href = 'hctrost://myEnergy';
    } else {
      // alert(
      //   '모바일 앱에서만 사용할 수 있어요. 트로스트 앱에서 더 다양한 기능을 편하게 이용하세요!',
      // );
      window.location.href = 'https://trost.onelink.me/F1Cv/05zw2po0';
    }
  }

  if (type === 'emotionScan') {
    window.location.href = 'hctrost://emotionScan';
  }

  if (type === 'authCorp') {
    window.location.href = isApp
      ? 'hctrost://authCorp/'
      : 'https://trost.onelink.me/F1Cv/05zw2po0';

    return true;
  }

  if (type === 'myInfo') {
    window.location.href = isApp
      ? 'hctrost://myInfo/'
      : 'https://trost.onelink.me/F1Cv/05zw2po0';

    return true;
  }

  if (type === 'myCounseling') {
    if (id) {
      window.location.href = isApp
        ? `hctrost://message?counselingNo=${id}`
        : 'https://trost.onelink.me/F1Cv/05zw2po0';
    } else {
      window.location.href = isApp
        ? 'hctrost://myCounseling?traffic_source=myspace'
        : 'https://trost.onelink.me/F1Cv/05zw2po0';
    }

    return true;
  }

  if (type === 'trostPay') {
    window.location.href = isApp
      ? 'hctrost://trostPay/'
      : 'https://trost.onelink.me/F1Cv/05zw2po0';

    return true;
  }

  if (type === 'favoritePartner') {
    window.location.href = isApp
      ? 'hctrost://favoritePartner/'
      : 'https://trost.onelink.me/F1Cv/05zw2po0';

    return true;
  }

  return false;
};

const transferServiceInApp = (data) => {
  let transferService = '';

  if (!isApp) {
    const query = data.indexOf('?') === 0 ? data.replace('?', '')
      .split('&') : data.split('&');

    if (query.indexOf('type=transfer') !== -1) {
      if (query.indexOf('location=mall') !== -1) {
        window.location.href = 'https://trost.cafe24.com';
        return true;
      }

      if (query.indexOf('location=findPartners') !== -1) {
        if (query.indexOf('partnerID=') !== -1) {
          // 상담사 프로필
          window.location.href = `/mobile/partner/detail/?partnerID=${query.split('partnerID=')[1]}`;
          return true;
        }

        window.location.href = '/counselor';
        return true;
      }

      if (query.indexOf('location=findRealtimePartners') !== -1) {
        window.location.href = '/service/new/realtime/search/';
        return true;
      }

      if (query.indexOf('location=notice') !== -1) {
        window.location.href = `/mobile/support/notice/?status=${query.split('status=')[1]}`;
        return true;
      }

      if (query.indexOf('location=poll') !== -1) {
        window.location.href = `/service/mentaltalk/poll/?id=${query.split('id')[1]}`;
        return true;
      }

      if (query.indexOf('location=mentalTalkPolls') !== -1) {
        if (query.indexOf('pollID') !== -1) {
          window.location.href = `/service/mentaltalk/poll/result/?pollID=${query.split('pollID')[1]}`;
        } else if (query.indexOf('id') !== -1) {
          window.location.href = `/service/mentaltalk/poll/result/?id=${query.split('id')[1]}`;
        } else {
          window.location.href = '/service/mentaltalk/poll/search/';
        }
        return true;
      }

      if (query.indexOf('location=findHospitals') !== -1) {
        let id = '';
        let reviewID = '';

        const splitQuery = query.split('&');
        for (let i = 0, len = splitQuery.length; i < len; i += 1) {
          if (splitQuery[i].indexOf('id=') !== -1) {
            id = `${splitQuery[i].split('=')[1]}`;
          }

          if (splitQuery[i].indexOf('reviewID=') !== -1) {
            reviewID = `${splitQuery[i].split('=')[1]}`;
          }
        }

        if (query.indexOf('id') !== -1) {
          if (query.indexOf('reviewID') !== -1) {
            window.location.href = `/service/offline/mobile/detail/?id=${id}&reviewID=${reviewID}`;
            return true;
          }

          window.location.href = `/service/offline/mobile/detail/?id=${id}`;
        } else {
          window.location.href = '/service/offline/mobile/';
        }

        return true;
      }

      if (query.indexOf('location=findMedicines') !== -1) {
        let id = '';
        let reviewID = '';

        const splitQuery = query.split('&');
        for (let i = 0, len = splitQuery.length; i < len; i += 1) {
          if (splitQuery[i].indexOf('id=') !== -1) {
            id = `${splitQuery[i].split('=')[1]}`;
          }

          if (splitQuery[i].indexOf('reviewID=') !== -1) {
            reviewID = `${splitQuery[i].split('=')[1]}`;
          }
        }

        if (query.indexOf('id') !== -1) {
          if (query.indexOf('reviewID') !== -1) {
            window.location.href = `/service/medicine/detail/?id=${id}&reviewID=${reviewID}`;
            return true;
          }

          window.location.href = `/service/medicine/detail/?id=${id}`;
        } else {
          window.location.href = '/service/medicine/';
        }

        return true;
      }

      if (query.indexOf('location=supportContact') !== -1) {
        let category = '';

        const splitQuery = query.split('&');
        for (let i = 0, len = splitQuery.length; i < len; i += 1) {
          if (splitQuery[i].indexOf('category=') !== -1) {
            category = `${splitQuery[i].split('=')[1]}`;
          }
        }

        if (category) {
          window.location.href = `/mobile/support/contact/?category=${category}`;
        } else {
          window.location.href = '/mobile/support/contact/';
        }
        return true;
      }
    }

    if (query.indexOf('type=previous') !== -1) {
      window.location.search = data;
    }
  } else {
    if (data.indexOf('trost.cafe24.com') !== -1) {
      window.location.search = 'type=transfer&location=mall';
      return true;
    }

    if (data.indexOf('transfer') !== -1) {
      window.location.search = data.indexOf('?') !== -1 ? data.split('?')[1] : data;
      return true;
    }

    if (data.indexOf('previous') !== -1) {
      window.location.search = data.indexOf('?') !== -1 ? data.split('?')[1] : data;
      return true;
    }

    const url = new URL(data);
    const {
      pathname,
    } = url;

    if (pathname === '/mobile/partner/search/') {
      locationMovement('findPartners', {});
    }

    if (pathname === '/mobile/partner/profile/' || pathname === '/mobile/partner/detail/') {
      const partnerId = getQuerystring('partnerID', url);
      locationMovement('findPartners', { id: partnerId });
    }

    if (pathname === '/service/new/realtime/search/') {
      transferService = 'type=transfer&location=findRealtimePartners';
    }

    // if (pathname === '/promotion/therapySpecialist/') {
    //   transferService = 'type=transfer&location=therapySpecialist';
    // }

    // if (pathname === '/promotion/specialPayment/') {
    //   transferService = 'type=transfer&location=specialPayment';
    // }

    // if (pathname === '/promotion/marriageTherapy/') {
    //   transferService = 'type=transfer&location=marriageTherapy';
    // }

    if (pathname === '/mobile/support/notice/') {
      const status = getQuerystring('status', url);
      transferService = `type=transfer&location=notice&options=status&status=${status}`;
    }

    if (pathname === '/service/mentaltalk/poll/') {
      const id = getQuerystring('id', url);
      transferService = `type=transfer&location=poll&options=id&id=${id}`;
    }

    if (pathname === '/service/mentaltalk/search/') {
      transferService = 'type=transfer&location=mentalTalkPolls';
    }

    if (pathname === '/service/mentaltalk/poll/result/') {
      const id = getQuerystring('id', url);
      transferService = `type=transfer&location=mentalTalkPolls&options=pollID&pollID=${id}`;
    }

    if (pathname === '/service/offline/mobile/detail/') {
      const id = getQuerystring('id', url);
      const reviewID = getQuerystring('reviewID', url);

      if (reviewID) {
        transferService = `type=transfer&location=findHospitals&options=id/reviewID&id=${id}&reviewID=${reviewID}`;
      } else {
        transferService = `type=transfer&location=findHospitals&options=id&id=${id}`;
      }
    }

    if (pathname === '/service/offline/mobile/') {
      transferService = 'type=transfer&location=findHospitals';
    }

    if (pathname === '/service/medicine/detail/') {
      const id = getQuerystring('id', url);
      const reviewID = getQuerystring('reviewID', url);

      if (reviewID) {
        transferService = `type=transfer&location=findMedicines&options=id/reviewID&id=${id}&reviewID=${reviewID}`;
      } else {
        transferService = `type=transfer&location=findMedicines&options=id&id=${id}`;
      }
    }

    if (pathname === '/service/medicine/') {
      transferService = 'type=transfer&location=findMedicines';
    }

    if (pathname === '/mobile/support/contact/') {
      const category = getQuerystring('category', url);
      const queryData = category ? `options=category&category=${category}` : '';

      transferService = `type=transfer&location=supportContact&${queryData}`;
    }

    if (transferService) {
      window.location.search = transferService;
    }
  }

  window.location.href = data;
};

export {
  locationMovement,
  webkitBridgeShowMiniBanner,
  transferServiceInApp,
  webkitBridgeWebviewCustomEvent,
  webkitBridgeWebviewFirebaseUserProperty,
  webkitBridgeWebviewBottomSheet,
  webkitBridgeMixpanelScreenView,
  webkitBridgeMixpanelCustomEvent,
  webkitBridgeMixpanelUserProperty,
  webkitBridgeAdjustEvent,
  webkitBridgeOpenExternalWeb,
  webkitBridgeShowIndicator,
  webkitBridgeCloseWebview,
  webkitBridgeClearCache,
  webkitBridgeShowAlert,
  webkitBridgeWebShare,
  connectToFindPartners,
  connectToFindPartnersLink,
};
